import { Community } from "../../models/community";
import { Result } from "../../models/result";

export const transformCommunityApiResults = (results: Community[]): Result[] => {
	const wrappedResults: Result[] = [];

	results?.forEach((result) => {
		if (result !== undefined) {
			let wrappedResult = {
				//Basic Info
				title: result.commName,
				imageSrc: result.commImageLink,
				uniqueId:
					result.commPageLink + "-" + result.commName + "-" + result.commBrand,
				url: result.commPageLink,
				availableHomes: result.commAvailableHomes,
				//Address
				address: result.commAddress,
				city: result.commAddress,
				//Location
				position: {
					latitude: result.commCoordsLat,
					longitude: result.commCoordsLng,
				},
				//Activation
				activationStateHex: result.commStatusColor,
				activationState: result.commSellingStatus,
				//Bedrooms
				bedrooms: [result.commMinBeds, result.commMaxBeds],
				hasBedrooms: result.commMinBeds > 0 || result.commMaxBeds > 0,
				//Bathrooms
				bathrooms: [result.commMinBaths, result.commMaxBaths],
				hasBathrooms: result.commMinBaths > 0 || result.commMaxBaths > 0,
				//Stories
				stories: [result.commMinStories, result.commMaxStories],
				hasStories: result.commMinStories > 0 || result.commMaxStories > 0,
				//Garages
				garages: [result.commMinCars, result.commMaxCars],
				hasGarage: result.commMinCars > 0 || result.commMaxCars > 0,
				//Price
				prices: [result.commMinPrice, result.commMaxPrice],
				//Size
				size: [result.commMinSqft, result.commMaxSqft],
				hasSize: result.commMinSqft > 0 || result.commMaxSqft > 0,
				//Amenities
				amenities: result.commAmenitiesList,
				//Call for Information
				callForPrice: result.commCallForPrice,

				//Should we show call for information, yes if the call for price
				// field is true or if the min price is not available.
				showCallForInfo: result.commCallForPrice || !(result.commMinPrice > 0),

				//Property Type
				propertyType: result.commPropertyType,

				//Home Series
				homeSeries: result.commBrand,
			} as Result;

			wrappedResults.push(wrappedResult);
		}
	});

	return wrappedResults;
};
